import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { SignSubmitData } from '@/models/sign-data/sign-submit-data.model';
import { IAuth } from '@/models/store/auth/auth.model';
import { TokenData } from '@/models/store/auth/token-data.model';
import { Module } from 'vuex';

export const authModule: Module<IAuth, unknown> = {
    state: {
        token: '',
        userEmail: 'not_set',
    },
    actions: {
        setEmail: ({ commit }, payload: string): void => {
            commit('setEmail', payload);
        },
        setToken: ({ commit }, payload: string): void => {
            commit('setToken', payload);
        },
        sendCodeEmail: async ({ commit }, payload: SignSubmitData): Promise<boolean> => {
            commit('setResponseStatus', true);

            const response = await fetch(`${environment.baseUrl}/api/client/code/email`, {
                method: 'post',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });

                return false;
            } else {
                commit('setResponseStatus', false);

                return true;
            }
        },
        verifyCode: async ({ commit }, payload: SignSubmitData): Promise<boolean | TokenData> => {
            commit('setResponseStatus', true);
            const response = await fetch(`${environment.baseUrl}/api/client/verify/code/email`, {
                method: 'post',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });

                return false;
            } else {
                const result = await response.json();
                commit('setResponseStatus', false);
                commit('setToken', result.token);

                return result;
            }
        },
    },
    mutations: {
        setToken: (store, payload: string): void => {
            store.token = payload;
        },
        setEmail: (store, payload: string): void => {
            store.userEmail = payload;
        },
    },
    getters: {
        getStoreToken: (store) => store.token,
        getUserEmail: (store) => store.userEmail,
    },
};
